import { call, put } from 'redux-saga/effects';

import { deleteSavedFilingPeriodSpreadsheetsSuccess } from '@actions/savedFilingPeriod';
import { deleteSpreadsheet } from '@api/spreadsheet';

export const deleteSpreadsheetSaga = function* ({ payload }) {
  yield call(deleteSpreadsheet, payload);

  yield put(deleteSavedFilingPeriodSpreadsheetsSuccess(payload));
};
